export const FORMAT_DATE = 'DD.MM.YYYY';
export const CURRENCY_USD = {
  id: 4,
  label: 'долларах',
  symbol: '$',
  code: 'USD',
};

export const CURRENCY_RUB = {
  id: 1,
  label: 'рублях',
  symbol: '₽',
  code: 'RUB',
};

export const ORDER_TYPE_OPT = 'OPT';
export const ORDER_TYPE_CUT = 'CUT';
export const ORDER_TYPE_ZGI = 'ZGI';

//eslint-disable-next-line
export const EMAIL_VALIDATOR = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

export const ORDER_STATUS = {
  DRAFT: {
    id: 0,
    name: 'Черновик',
    vendor_code: 'DRAFT',
    status: null,
    sort_order: null,
    rgb_color: 'A1A1A1',
    is_hidden: null,
  },
  NEW_ORDER: {
    id: 1,
    name: 'Новый заказ',
    vendor_code: 'NEW_ORDER',
    status: 1,
    sort_order: 200,
    rgb_color: 'transparent',
    is_hidden: null,
  },
  TAKEN_TO_WORK: {
    id: 2,
    name: 'Взят в работу',
    vendor_code: 'TAKEN_TO_WORK',
    status: 1,
    sort_order: 180,
    rgb_color: 'C298D1',
    is_hidden: null,
  },
  MEASUREMENT_ASSIGNED: {
    id: 3,
    name: 'Замер назначен',
    vendor_code: 'MEASUREMENT_ASSIGNED',
    status: 1,
    sort_order: 160,
    rgb_color: 'F2EDBC',
    is_hidden: 'b2b_zgi,b2b_cut,b2b_opt',
  },
  PRODUCTION_ORDER: {
    id: 4,
    name: 'Заказ в производстве',
    vendor_code: 'PRODUCTION_ORDER',
    status: 1,
    sort_order: 140,
    rgb_color: '6E99D9',
    is_hidden: 'b2b_opt',
  },
  SHIPMENT_ORDER: {
    id: 5,
    name: 'Заказ на отгрузке',
    vendor_code: 'SHIPMENT_ORDER',
    status: 1,
    sort_order: 120,
    rgb_color: 'C9EB80',
    is_hidden: null,
  },
  ORDER_COMPLETED: {
    id: 6,
    name: 'Заказ выполнен',
    vendor_code: 'ORDER_COMPLETED',
    status: 1,
    sort_order: 80,
    rgb_color: '6FAC6E',
    is_hidden: null,
  },

  ORDER_CANCELLED: {
    id: 7,
    name: 'Заказ отменен',
    vendor_code: 'ORDER_CANCELLED',
    status: 1,
    sort_order: 60,
    rgb_color: 'B83B50',
    is_hidden: null,
  },
  NON_TARGET_ORDER: {
    id: 8,
    name: 'Нецелевой заказ',
    vendor_code: 'NON_TARGET_ORDER',
    status: 1,
    sort_order: 50,
    rgb_color: 'C8CDD4',
    is_hidden: null,
  },
  ORDER_SHIPPED: {
    id: 9,
    name: 'Заказ отгружен',
    vendor_code: 'ORDER_SHIPPED',
    status: 1,
    sort_order: 90,
    rgb_color: '86D774',
    is_hidden: 'zgi',
  },

  RETURNED_BY_SUPPLIER_FOR_REVISION: {
    id: 10,
    name: 'Возвращен на доработку',
    vendor_code: 'RETURNED_BY_SUPPLIER_FOR_REVISION',
    status: 1,
    sort_order: 70,
    rgb_color: 'E2C055',
    is_hidden: 'zgi',
  },
  ORDER_APPROVAL: {
    id: 11,
    name: 'Согласование заказа',
    vendor_code: 'ORDER_APPROVAL',
    status: 1,
    sort_order: 170,
    rgb_color: '8F74C6',
    is_hidden: null,
  },
  INSTALLATION_ASSIGNED: {
    id: 12,
    name: 'Монтаж назначен',
    vendor_code: 'INSTALLATION_ASSIGNED',
    status: 1,
    sort_order: 150,
    rgb_color: 'F3CCC0',
    is_hidden: 'b2b_zgi,b2b_cut,b2b_opt',
  },
  ORDER_ACCEPTED: {
    id: 14,
    name: 'Заказ принят',
    vendor_code: 'ORDER_ACCEPTED',
    status: 1,
    sort_order: 190,
    rgb_color: 'DBC3E3',
    is_hidden: null,
  },
  ORDER_RESERVED: {
    id: 15,
    name: 'Заказ зарезервирован',
    vendor_code: 'ORDER_RESERVED',
    status: 1,
    sort_order: 145,
    rgb_color: '8BCEDC',
    is_hidden: null,
  },
  ORDER_IS_READY: {
    id: 16,
    name: 'Заказ готов',
    vendor_code: 'ORDER_IS_READY',
    status: 1,
    sort_order: 130,
    rgb_color: '383A77',
    is_hidden: null,
  },
};

export const ADMINISTRATOR_TEXT = 'Администратор';
export const ACTION_MENU_ARCHIVED_STATUS_CODE = [
  ORDER_STATUS.ORDER_COMPLETED.vendor_code,
  ORDER_STATUS.ORDER_CANCELLED.vendor_code,
  ORDER_STATUS.NON_TARGET_ORDER.vendor_code,
];

export const FINAL_ORDER_STATUSE_CODE = [
  ORDER_STATUS.ORDER_COMPLETED.vendor_code,
  ORDER_STATUS.ORDER_CANCELLED.vendor_code,
  ORDER_STATUS.NON_TARGET_ORDER.vendor_code,
];

export const MODEL_OPTIONS = {
  // сторона наклона/уклона
  TILT_SIDE: {
    code_1c: 'СторонаНаклона',
  },
  // Наклонный карниз
  SLOPING_CORNICE: {
    code_1c: 'РеквБулево_1',
  },
  // Нестандартное изделие
  NOT_STANDARD: {
    code_1c: 'Нестандарт',
    name: 'Нестандартное изделие',
  },
  ELECTRIC_DRIVE: {
    code_1c: "Электропривод",
    vendor_code: "Электропривод",
    name: "Электропривод",
    use_type: "electric_drive",
  },
};

export const ORDER_ITEM_OPT_NAMES = [
  'Профиль',
  'Стержень',
  'Карниз',
  'Прут',
  'Труба',
  'Направляющая',
  'Планка',
  'Трубка',
  'Рейка',
  'Цепь',
  'Веревка',
  'Шлегель',
];

export const ORDER_ITEM_OPT_PATTERN_REGEXP = new RegExp(
  ORDER_ITEM_OPT_NAMES.reduce((acc, value, idx) => {
    const name = value.toLowerCase();
    if (!acc) {
      acc += `/(^${name})`;
    } else if (ORDER_ITEM_OPT_NAMES.length - 1 === idx) {
      acc += `|(^${name})/i`;
    } else {
      acc += `|(^${name})`;
    }
    return acc;
  }, ''),
);

export const ORDER_ITEMS = {
  SERVICES: {
    name: 'услуга',
    names: 'услуги',
    CUTTING_OF_MATERIALS: {
      id: '00013295',
      name: 'Услуга порезки материалов',
    },
  },
};

export const ZGI_OPTIONS_EXCEPTIONS = ['ЧислРеквизит1', 'ЧислРеквизит2', 'ЧислРеквизит21'];
